// extracted by mini-css-extract-plugin
export default {"cardContainer":"Service_cardContainer__4T1nR","cardTitle":"Service_cardTitle__olCkZ","serviceMainTitle":"Service_serviceMainTitle__83tOE","bottom":"Service_bottom__nd2Qg"};